import { Popover, PopoverAnchor, PopoverTrigger } from '@purinanbm/pds-ui';
import React from 'react';
import { IInnerProps } from '../types';
import { PopoverContent } from './ForceMountPopover';
import { HotspotContent } from './HotspotContent';
import { HotspotTrigger } from './HotspotTrigger';

export const HotspotPopover: React.FC<IInnerProps> = ({ point, markerContent, markerMedia }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { name } = markerContent;

  return (
    <Popover modal={isOpen} open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <HotspotTrigger
          name={name}
          markerMedia={markerMedia}
          style={{
            left: `${point.x}%`,
            top: `${point.y}%`,
          }}
        >
          <PopoverAnchor className="pds-absolute" />
        </HotspotTrigger>
      </PopoverTrigger>
      <PopoverContent
        collisionPadding={24}
        avoidCollisions
        side="right"
        background="light"
        sideOffset={16}
        isOpen={isOpen}
        onEscapeKeyDown={() => setIsOpen(false)}
      >
        <HotspotContent hotspot={markerContent} />
      </PopoverContent>
    </Popover>
  );
};
